<div class="client-form" *ngIf="isValid$ | async; else invalidForm" #container>
  <div
    *ngIf="clientFormDataObs | async as clientFormData; else loader"
    class="mx-auto py-2"
    style="max-width: 1200px; width: 100%; padding: 1rem"
  >
    <div class="card mb-2">
      <div class="card-body">
        <div class="card-title">
          {{ clientFormData.title }}
        </div>
        <div *ngIf="clientFormData.description">
          {{ clientFormData.description }}
        </div>
      </div>
    </div>
    <client-form-page-steps
      [inputContentGroupList]="clientFormData.inputContentGroups"
      [licenseId]="clientFormData.licenseId"
      [preview]="preview"
      [processing$]="processing$"
      [isValid$]="isValid$"
      (formSubmit)="submit($event)"
    >
    </client-form-page-steps>
  </div>
</div>
<ng-template #invalidForm>
  <h2 class="p-2 text-center">Something is wrong. Try again.</h2>
</ng-template>
<ng-template #loader>
  <app-loader></app-loader>
</ng-template>
